// extracted by mini-css-extract-plugin
export default {"root":"ReviewContentMatched-module-root-YmBJH","sliderWrapper":"ReviewContentMatched-module-sliderWrapper-i9iWU"};